import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { encryptStorage } from "../constant";

/**
 * PC_Cc_04 getCountData gets imported from api.js file
 */
import { getCountData } from "../service/api";
import '../components/css/Dashboard-styles.css'

export default function CountData() {

    /**
     * PC_Cc_02
     * The count,role state variable is created for storing the response data
     */

    let [counts, setCounts] = useState({})

    const [role, setRole] = useState()

    const navigate = useNavigate()

    /**
      * PC_Cc_03
      * Use Efffect method is called to get role from session and store it
      */

    useEffect(() => {

        setRole(encryptStorage.getItem('role'))

        fetchapi()

    }, [])

    /**
 * PC_Cc_06
 * The fetchApi function in the useEffects gets invoked which inturn call the getCountData() function with respective parameters
 */

    const fetchapi = async () => {

        const resp = await getCountData()

        if (resp.data.ResponseData !== undefined) {

            setCounts(resp.data.ResponseData)
        }

    }

    /**
     * PC_Cc_10
     * The response data gets stored in the count variable and mapped to each of its div
     */

    const countBody = () => {
        try {

            return (

                <div className="dashboard-custom-col-35 rounded-5">
                    <div className=" d-flex justify-content-between">
                        <div className="dashboard-custom-col-50 dashboard-card-padding-30 px-2">
                            <h2 className="tt-bold dashboard-activities-count"><span className="px-3"><img src="/Images/Touchbase.png" className="dashboard-style-49" /></span><span className="align-middle dashboard-activities-count">{counts.touchBaseCount}</span></h2>
                            <a className="tt-bold px-3 py-1 font-13 dashboard-link text-decoration-none" href="/touchbase">Touchbase Meetings</a>
                        </div>
                        {
                            (role == 'Hr Manager' || role == 'Hr') ? <div className="dashboard-custom-col-50 dashboard-card-padding-30 px-2">
                                <h2 className="tt-bold dashboard-activities-count"><span className="px-3"><img src="/Images/Profile Update.png" className="dashboard-style-49" /></span><span className="align-middle dashboard-activities-count">{counts.profileUpdateRequestCount}</span></h2>
                                <a className="tt-bold px-3 py-1 font-13 dashboard-link text-decoration-none" onClick={() => { navigate('/profileupdate', { state: { way: "dashboard" } }) }} /*href="/profileupdate" */>Profile Update Request</a>
                            </div> : <div className="dashboard-custom-col-50 dashboard-card-padding-30 px-2">
                                <h2 className="tt-bold dashboard-activities-count"><span className="px-3"><img src="/Images/Profile Update.png" className="dashboard-style-49" /></span><span className="align-middle dashboard-activities-count">{counts.disagreedFeedbackCount}</span></h2>
                                <a className="tt-bold px-3 py-1 font-13 dashboard-link text-decoration-none" href={`/FeedbackGrid?EmpId=${encryptStorage.getItem('employeeId')}&response=Disagree&evaluationid=${encryptStorage.getItem('CurrentEvaluationId')}`}>Disagreed Feedback</a>
                            </div>
                        }

                    </div>
                    <div className=" d-flex justify-content-between">
                        <div className="dashboard-custom-col-50 mt-3 dashboard-card-padding-30 px-2">
                            <h2 className="tt-bold dashboard-activities-count"><span className="px-3"><img src="/Images/Leave Request.png" className="dashboard-style-49" /></span><span className="align-middle dashboard-activities-count">{counts.leaveRequestCount}</span></h2>
                            <a className="tt-bold px-3 py-1 font-13 dashboard-link text-decoration-none" href="/leavewfh">Leave Request</a>
                        </div>
                        <div className="dashboard-custom-col-50 mt-3 dashboard-card-padding-30 px-2">
                            <h2 className="tt-bold dashboard-activities-count"><span className="px-3"><img src="/Images/WFH Request.png" className="dashboard-style-49" /></span><span className="align-middle dashboard-activities-count">{counts.wfhRequestCount}</span></h2>
                            <a className="tt-bold px-3 py-1 font-13 dashboard-link text-decoration-none" href="/leavewfh?tab=allwfh">WFH Request</a>
                        </div>
                    </div>
                </div>


            )
        }
        catch (e) {

        }
    }


    return (

        <>
            {countBody()}

        </>
    )
}

